import styled from 'styled-components';

export {
  ButtonWrapper,
  Form,
} from '../../login/email/form.styles';

export const Heading = styled.h2`
  margin-bottom: -12px;
  font-size: 16px;
  text-align: left;
`;

export const Bold = styled.p`
  margin: 0;
  text-align: left;
  font-weight: bold;
`;
